import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  cardContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  imageContainer: {
    width: "100%",
  },
  noDataIcon: {
    marginBottom: theme.spacing(5),
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      height: "50%",
      width: "70%",
    },
  },
  noDataText: {
    color: "#00003D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
    },
  },
}))

export default styles
